import React, { FC, memo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import GenButton, { GenButtonProps } from "../GenButton/GenButton";
import { CircularProgress } from "@mui/material";

export interface GenDialogProps {
  open: boolean;
  title?: string;
  description?: string;
  content?: React.ReactNode;
  primaryButtonLabel?: string;
  primaryButtonProps?: GenButtonProps;
  secondaryButtonLabel?: string;
  secondaryButtonProps?: GenButtonProps;
  onClickPrimaryButton?: () => void;
  onClickSecondaryButton?: () => void;
  loading?: boolean;
}

const GenDialog: FC<GenDialogProps> = (props) => {
  const {
    open = false,
    title,
    description,
    content,
    primaryButtonLabel,
    primaryButtonProps,
    onClickPrimaryButton,
    secondaryButtonLabel,
    secondaryButtonProps,
    onClickSecondaryButton,
    loading,
  } = props;

  return (
    <Dialog open={open} maxWidth="lg">
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent sx={{ minWidth: 400 }}>
        {description ? (
          <Typography whiteSpace={"pre"}>{description}</Typography>
        ) : null}
        {content}
      </DialogContent>
      <DialogActions
        sx={{ justifyContent: "center", marginBottom: 2, marginX: 2 }}
      >
        {loading && <CircularProgress size={24} sx={{ marginRight: 2 }} />}
        {secondaryButtonLabel && (
          <GenButton
            color="secondary"
            onClick={onClickSecondaryButton}
            sx={{ marginRight: 2 }}
            {...secondaryButtonProps}
          >
            {secondaryButtonLabel}
          </GenButton>
        )}
        <GenButton
          onClick={onClickPrimaryButton}
          autoFocus
          {...primaryButtonProps}
        >
          {primaryButtonLabel}
        </GenButton>
      </DialogActions>
    </Dialog>
  );
};

export default memo(GenDialog);
